import { render } from "./BottomLinks.vue?vue&type=template&id=9449a65e&scoped=true"
const script = {}

import "./BottomLinks.vue?vue&type=style&index=0&id=9449a65e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9449a65e"]])

export default __exports__